'use strict';

angular.module("newCustomerApp")
    .controller('NewCustomerController', NewCustomerController);

NewCustomerController.$inject = ['$scope', '$rootScope', '$http', 'Notification', '$uibModal', '$location',
    'CountriesListService', 'routesConstant', 'baseUrlConstant', 'routeHelper'];

function NewCustomerController($scope, $rootScope, $http, Notification, $uibModal, $location, CountriesListService,
                               routesConstant, baseUrlConstant, routeHelper) {

    angular.extend($scope, {
        registerNewUser: registerNewUser,
        showContact: showContact,
        url: url
    });

    (function init() {

        ["aerosVersion", "buildNumber"].forEach(function (item) {
            $scope[item] = window.serverSideParams['newCustomer.jsp'][item];
        });

        $scope.routesConstant = routesConstant;
        $scope.isHtml5Mode = $location.$$html5;

        $rootScope.page = {
            title: "Register for aeRos&reg; Account Page",
            type: undefined,
            instructions: "(To Be Added)",
            actions: [],
            showInstructions: showInstructionsModal
        };

        $scope.countries = CountriesListService.getCountries();

        $scope.newUserModel = {
            licenseKey: "",
            rogueSerial: "",
            poNumber: "",

            orgName: "",
            orgFirstName: "",
            orgLastName: "",
            orgEmail: "",
            orgPhone: "",
            orgAddress: "",
            orgAddressLine2: "",
            orgCity: "",
            orgState: "",
            orgZipCode: "",
            orgCountry: "",

            useOrgInfoAsAlternate: true,

            firstName: "",
            lastName: "",
            phone: "",
            email: "",
            address: "",
            addressLine2: "",
            city: "",
            state: "",
            zipCode: "",
            country: ""
        };

        $scope.contact = {
            "Email": "aeros.support@aflglobal.com",
            "Phone": "1-800-321-5298: press option 3"
        };

        $scope.finishUrl = url(routesConstant.LOGIN.CUSTOMER);
    }());

    function showInstructionsModal() {
        $uibModal.open({
            templateUrl: "pageInstructionsModal.html",
            resolve: {
                page: function () {
                    return $scope.page;
                },
                contact: function () {
                    return $scope.contact;
                }

            },
            controller: ["$scope", "page", "contact", function ($scope, page, contact) {
                $scope.page = page;
                $scope.contact = contact;
            }]
        });
    }

    function registerNewUser() {
        $http.post(baseUrlConstant + "/newCustomer", $scope.newUserModel)
            .success(function (rsp) {

                $uibModal.open({
                    templateUrl: 'pageRegistrationSuccessModal.html',
                    resolve: {
                        finish: function () {
                            return $scope.finishUrl;
                        }
                    },
                    controller:["$scope", "finish", function ($scope, finish) {
                        $scope.finishUrl = finish;
                    }]
                });

            })
            .error(function (err) {
                Notification.error("User not registered, " + err.message);
            });
    }

    function showContact() {
        $uibModal.open({
            templateUrl: 'contactInfoModal.html',
            resolve: {
                contact: function () {
                    return $scope.contact;
                }
            },
            controller: ["$scope", "contact", function ($scope, contact) {
                $scope.contact = contact;
            }]
        });
    }

    function url(routeConst) {
        return routeHelper.url(routeConst, $scope.isHtml5Mode);
    }
}
